import { render, staticRenderFns } from "./sortableColumnHead.vue?vue&type=template&id=2de27e1e"
import script from "./sortableColumnHead.vue?vue&type=script&lang=js"
export * from "./sortableColumnHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports